export const downloadcsvbase64 = (namefile, data) => {
  const csvUrl = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = csvUrl;
  link.setAttribute('download', `${namefile}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
